module.exports = "/assets/success-muffin-rw.png?qXEB4By";